export default {
  group: {
    default: 'Groupe | Groupes',
    info: 'Au delà de six personnes nous négocions des tarifs préférentiels et reservons pour votre groupe selon vos critères',
    form: {
      title: 'Demande de groupe',
      destination: {
        label: 'destination',
        placeholder: 'Où souhaitez-vous aller ?'
      },
      description: {
        label: 'description'
      },
      budget: {
        label: 'budget par personne',
        placeholder: 'Saisissez le montant souhaité'
      },
      hotel: {
        label: 'type d\'hôtel souhaité',
        placeholder: 'Sélectionnez un type d\'hôtel'
      },
      request: {
        label: 'réponse souhaitée avant le',
        placeholder: '.. / .. / ....'
      }
    }
  }
}
